module.exports = __webpack_public_path__ + "images/f27cf0b.png";